let filtersGroups = document.querySelectorAll('.js-filter');

if (filtersGroups) {


    let url = window.location.origin + window.location.pathname,
        filterForm = document.querySelector('.js-filter-form');

    function checkForMoney() {
        let query = window.location.search;
        let urlParams = new URLSearchParams(query);
        let money = urlParams.get('filter.v.price.lte');

        console.log(money);

        if (money) {

            let moneyArray = money.split(',');
            moneyArray.forEach(moneyValue => {
                let filterInput = document.querySelector('.js-filter-input[value="' + moneyValue +'"]');
                if (filterInput) {
                    filterInput.checked = true;
                }
            });

        }

    }
    checkForMoney(); 
    
    function getFilterValues() {

        let url = window.location.origin + window.location.pathname;

        if (window.location.search) {
            let query = window.location.search;
            let urlParams = new URLSearchParams(query);
            let search = urlParams.get('q');
            
            url += '?q=' + search;
            
        }


        filtersGroups.forEach(filterGroup => {

            let filterInputs = filterGroup.querySelectorAll('input[type="checkbox"]'),
                filterValues = [],
                filterName = filterGroup.dataset.param_name;

            filterInputs.forEach(filterInput => {
                if (filterInput.checked) {
                    filterValues.push(filterInput.value.replace(/ /g, '%20').replace(/\+/g, '%2B').replace(/\//g, '%2F'));
                }
            });

            if (filterValues.length > 0) {
                
                if (url.includes('?')) {
                    url += '&' + filterName + '=' + filterValues.join(',');
                } else {
                    url += '?' + filterName + '=' + filterValues.join(',');
                }
            }
        });


        // return filterValues;

        window.location.href = url; 

    }

    function clearAllFilters() {
        // Uncheck all filter checkboxes
        let allFilterInputs = document.querySelectorAll('.js-filter-input[type="checkbox"]');
        allFilterInputs.forEach(input => {
            input.checked = false;
        });

        // Navigate to the base collection URL without filters
        let url = window.location.origin + window.location.pathname;
        
        // Preserve search query if it exists
        if (window.location.search) {
            let urlParams = new URLSearchParams(window.location.search);
            let search = urlParams.get('q');
            if (search) {
                url += '?q=' + search;
            }
        }
        
        window.location.href = url;
    }

    // Remove automatic form submission on change
    // filterForm.addEventListener('change', (e) => {
    //     getFilterValues();
    // });

    // Add apply filters functionality
    let applyFiltersBtn = document.querySelector('.js-apply-filters');
    let clearFiltersBtn = document.querySelector('.js-clear-filters');

    if (applyFiltersBtn) {
        applyFiltersBtn.addEventListener('click', (e) => {
            e.preventDefault();
            getFilterValues();
        });
    }

    if (clearFiltersBtn) {
        clearFiltersBtn.addEventListener('click', (e) => {
            e.preventDefault();
            clearAllFilters();
        });
    }

    let filterTriggers = document.querySelectorAll('.js-filter-trigger');
    filterTriggers.forEach(filterTrigger => {
        filterTrigger.addEventListener('click', (e) => {
            filterTrigger.classList.toggle('active');
            let filterGroup = filterTrigger.nextElementSibling;
            filterGroup.classList.toggle('active');
        });
    });

    // Initial accordion state setup - this will be enhanced by filter-availability.js
    filtersGroups.forEach(filterGroup => {
        let filterInputs = filterGroup.querySelectorAll('input[type="checkbox"]');
        filterInputs.forEach(filterInput => {
            if (filterInput.checked) {
                filterGroup.querySelector('.js-filter-trigger').classList.add('active');
                filterGroup.querySelector('.js-filter-group').classList.add('active');
            }
        });
    });
    
}



